import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Form, Select, DatePicker } from 'antd'
import "./fissionstaManagement.less"
const { Option } = Select;
const { RangePicker } = DatePicker;
class FissionstaManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			name: '',
			departmentName: '',
			token: '',
			url: '',
			introduction: '',
			dataSource: [],
			qiuniuUrl: '',
			qrcodeId: null,
			endTime: undefined,
			startTime: undefined,
			groupId: undefined,
			optionList: [],
			dateKey: undefined,
			searchData: {
				total: 0,
				pageNum: 1,
				pageSize: 10
			},
			columns: [
				{
					title: '部门名称',
					dataIndex: 'groupName',
					key: 'groupName',
					align: 'center',
				},
				{
					title: '客服名称',
					dataIndex: 'kefuName',
					key: 'kefuName',
					align: 'center'
				},

				{
					title: '有手机号',
					dataIndex: 'havePhone',
					key: 'havePhone',
					align: 'center'
				},
				{
					title: '无手机号',
					dataIndex: 'noPhone',
					key: 'noPhone',
					align: 'center'
				},
				{
					title: '总数量',
					dataIndex: 'num',
					key: 'num',
					align: 'center'
				},
				// {
				// 	title: '有手机号',
				// 	dataIndex: 'isPhone',
				// 	key: 'isPhone',
				// 	align: 'center',
				// 	render: (record) => {
				// 		if (record === 1) {
				// 			return '否'
				// 		}
				// 		if (record === 2) {
				// 			return '是'
				// 		}
				// 	}
				// }
			]
		}
	}
	componentDidMount() {
		this.getList()
		this.getOption()
	}
	async getList() {
		axios.post('userController/getTeachersShareNum', {
			...this.state.searchData,
			tid: this.state.groupId,
			endTime: this.state.endTime,
			startTime: this.state.startTime
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					dataSource: res.data.data?.list,
					searchData: {
						pageNum: res.data.data?.pageNum,
						pageSize: res.data.data?.pageSize,
						total: res.data.data?.total
					}
				})
			}
		})
	}
	getOption() {
		axios.get('userController/getDepartmentList').then(res => {
			if (res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					optionList: arr
				})
			}
		})
	}
	exportData() {
		// window.location.href = `http://192.168.40.55:8686/video-wechat-manager/api/userController/export?endTime=${this.state.endTime}&startTime=${this.state.startTime}&autoSyn=${this.state.autoSyn}&isHas=${this.state.isHas}&isTeacher=${this.state.isTeacher}`
		let tid = this.state.groupId === undefined ? '' : this.state.groupId
		let startTime = this.state.startTime === undefined ? '' : this.state.startTime
		let endTime = this.state.endTime === undefined ? '' : this.state.endTime
		axios.get(`/userController/getTeachersShareNumExport?startTime=${startTime}&endTime=${endTime}&tid=${tid}`, { responseType: 'blob' }).then(res => {
			const link = document.createElement('a')
			let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.setAttribute('download', '咨询师列表.xlsx')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		})
	}
	render() {
		const { dataSource, columns, searchData } = this.state;
		const pagination = {
			showSizeChanger: true,
			total: searchData.total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${searchData.total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getList(searchData)
			},
		}
		return (
			<div className='fissionstaManagement'>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>全员裂变统计</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Select placeholder="选择部门" value={this.state.groupId} allowClear style={{ width: 140, height: '40px', marginRight: '10px' }} onChange={(value) => {
							this.setState({
								groupId: value
							})
						}}>
							{this.state.optionList.map(item => {
								return (<Option key={item.id + item.name} value={item.id}>{item.name}</Option>)
							})}
						</Select>
						<RangePicker key={this.state.dateKey} style={{height: '40px'}} onChange={(date, dateString) => {
							console.log(date, dateString);
							this.setState({
								startTime: dateString[0],
								endTime: dateString[1]

							})
						}} />
						<Button className='my-button-primary' style={{marginLeft: '20px', marginRight: '20px' }} onClick={() => {
							this.getList()
						}} type='primary'>搜索</Button>
						<span className='my-button-txt' onClick={() => {
							this.setState({
								groupId: undefined,
								endTime: "",
								startTime: "",
								dateKey: new Date()
							}, () => {
								this.getList()
							})
						}} type='primary'>重置</span>
					</div>
					<div>
						{/* <Button className='my-button-primary' type='primary'  onClick={() => { this.showModal() }}>新增</Button> */}
						<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.exportData()
						}}>导出</Button>
					</div>
				</div>
				<Table pagination={pagination} dataSource={dataSource} columns={columns} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')} rowKey={(record, index) => index} />
			</div>
		)
	}
}

export default Form.create()(FissionstaManagement)